module.exports = __webpack_public_path__ + "static/media/09.b2818daa.jpg";